var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "automation-wizard-overview-benefits" }, [
    _c(
      "p",
      {
        staticClass:
          "automation-wizard-overview-benefits__title typographies-paragraph-medium-semibold"
      },
      [_vm._v("\n        " + _vm._s(_vm.translations.title) + "\n    ")]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "automation-wizard-overview-benefits__list" },
      [
        _vm._l(_vm.benefits, function(benefit, index) {
          return [
            _c(
              "div",
              {
                key: index,
                staticClass: "automation-wizard-overview-benefits__list-item"
              },
              [
                _c("CompassIcon", {
                  staticClass: "automation-wizard-overview-benefits__icon",
                  attrs: { icon: "success-circle-fill", size: "small" }
                }),
                _vm._v(" "),
                _c(
                  "p",
                  {
                    staticClass:
                      "automation-wizard-overview-benefits__label typographies-paragraph-small"
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(benefit) +
                        "\n                "
                    )
                  ]
                )
              ],
              1
            )
          ]
        })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }